import Dialog, { IDialogProps } from '@/ui/dialog';
import { Button } from '@/ui/buttons';
import { CloseX, Loading } from '@/ui/svg';
import BitpointNotEnough from './bitpoints-not-enough';
import CreateWalletSuccess from './create-wallet-success';
import { useCreateWallet } from '@bitbot/model';
import { useGlobalValueStore } from '@bitbot/model';
import clsx from 'clsx';
import InputWalletName from '../input-wallet-name';

export default function SetWalletNameDialog(props: IDialogProps) {
  const {
    name,
    setName,
    showNotEnough,
    setShowNotEnough,
    showSuccess,
    setShowSuccess,
    settingName,
    isCreatingWallet,
    editWallet,
  } = useCreateWallet();
  const { showInputWalletName, setShowInputWalletName } =
    useGlobalValueStore();
  const disabled = name.trim() === '';
  const successToggle = (value: boolean) => {
    setShowSuccess(value);
  };

  return (
    <>
      <Dialog {...props}>
        {showInputWalletName && (
          <InputWalletName name={name} setName={setName} />
        )}
        <div className="px-2">
          <div className="text-center text-lg font-bold">
            Set wallet name
          </div>
          <div className="relative flex mt-7 px-4">
            <div
              onClick={() => {
                setShowInputWalletName(true);
              }}
              className={clsx(
                'bg-transparent outline-none border-primary border-[1px] rounded-2xl w-0 flex-grow py-3 pl-4 pr-8 ',
                name === '' ? 'text-quaternary' : '',
              )}
            >
              {name === '' ? 'Wallet name' : name}
            </div>
            {name !== '' && (
              <div
                onClick={() => {
                  setShowInputWalletName(true);
                }}
                className="absolute w-8 top-0 bottom-0 right-4 flex items-center cursor-pointer"
              >
                <CloseX className="w-5 h-5 text-tertiary" />
              </div>
            )}
          </div>
          <div className="px-4 mt-40">
            <Button
              onClick={() => {
                if (!disabled && !settingName) {
                  editWallet();
                }
              }}
              size="sm"
              type={disabled || settingName ? 'disabled' : 'primary'}
            >
              {settingName ? (
                <>
                  Setting Wallet Name
                  <Loading className="w-5 h-5 ml-3" />
                </>
              ) : (
                'Create'
              )}
            </Button>
          </div>
        </div>
      </Dialog>
      <BitpointNotEnough
        open={showNotEnough}
        toggle={setShowNotEnough}
        hideCloseIcon
      />
      <CreateWalletSuccess
        open={showSuccess}
        toggle={successToggle}
        hideCloseIcon
      />
    </>
  );
}
